import { axios } from 'lib'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

type Params = {
  simulationId: string
  name: string
  username: string
  type: string
}

const getLead = async (params: Params): Promise<any> => {
  const result = await axios.get(`financial/lead/${params.simulationId} `, {
    params
  })
  return result

  const simulationId = params.simulationId

  return {
    redirect_url: `https://pipertecnologia.com/simulation/${simulationId}`
  }
}

export function useGetLead() {
  return useMutation(getLead, {
    onSuccess: (data) => {
      const redirectUrl = data.redirect_url
      window.open(redirectUrl, '_blank')
      // toast.success('Simulação solicitada!')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível obter a simulação.')
    }
  })
}
